import { render, staticRenderFns } from "./UUploadFile.vue?vue&type=template&id=3907d093&scoped=true&"
import script from "./UUploadFile.vue?vue&type=script&lang=js&"
export * from "./UUploadFile.vue?vue&type=script&lang=js&"
import style0 from "./UUploadFile.vue?vue&type=style&index=0&id=3907d093&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3907d093",
  null
  
)

export default component.exports